import OrganizersList from "./organizersList";

export default OrganizersList;
